import { useEffect } from 'react';

import { useJobId } from 'src/context/useJobId';
import { useEnhancedHubble } from 'src/hooks/useEnhancedHubble';
import type { HubbleEventName } from 'src/modules/analytics.types.ts';
import { getJobSolMetadata } from 'src/modules/solTracker/solMetadata';

export function useHubbleImpression(
  eventName: HubbleEventName,
  trackingCorrelationId?: string,
  additionalTrackingProps: Record<string, unknown> = {},
) {
  const { jobId } = useJobId();
  const hubble = useEnhancedHubble();

  useEffect(() => {
    const solMetadata = getJobSolMetadata(jobId);

    hubble.trackEvent(
      eventName,
      {
        jobId,
        solMetadata,
        ...additionalTrackingProps,
      },
      { trackingCorrelationId },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hubble, jobId, eventName, trackingCorrelationId]);

  return hubble;
}
